import React from "react";

const sectionStyle = {
  background: "#fff",
  padding: "25px",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  marginBottom: "25px",
};

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        maxWidth: "1000px",
        margin: "40px auto",
        padding: "20px",
        lineHeight: "1.8",
        fontFamily: "Arial, Helvetica, sans-serif",
        color: "#333",
        background: "#f7f7f7",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          color: "#0b5ed7",
          marginBottom: "10px",
        }}
      >
        Privacy Policy
      </h1>

      <p style={{ textAlign: "center", color: "#666" }}>
        Effective Date: July 2026
      </p>

      <div style={sectionStyle}>
        <h2>1. Introduction</h2>

        <p>
          Cleanup Car Service Pvt Ltd. ("Cleanup", "we", "our", or "us")
          respects your privacy and is committed to protecting your personal
          information.
        </p>

        <p>
          This Privacy Policy explains how we collect, use, and protect
          information when you use our website and mobile applications.
        </p>

        <p>This Privacy Policy applies to:</p>

        <ul>
          <li>Cleanup Customer Mobile Application</li>
          <li>Cleanup Partner Mobile Application</li>
          <li>Cleanup Website</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2>2. Information We Collect</h2>

        <h3>Customer Application</h3>

        <ul>
          <li>Name</li>
          <li>Mobile Number</li>
          <li>Email Address</li>
          <li>Service Address</li>
          <li>Vehicle Information</li>
          <li>Booking History</li>
          <li>Subscription Details</li>
        </ul>

        <h3>Partner Application</h3>

        <p>
          The Partner App is designed only for authorized employees or service
          partners.
        </p>

        <p>
          Accounts are created by the Cleanup administrator. Users cannot
          register themselves through the Partner App.
        </p>

        <ul>
          <li>Name</li>
          <li>Mobile Number</li>
          <li>Employee / Partner ID</li>
          <li>Login Credentials</li>
          <li>Assigned Service Orders</li>
          <li>Service Completion Details</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2>3. Camera Permission</h2>

        <p>
          The Partner App requires camera permission to capture service
          photographs.
        </p>

        <p>These photographs include:</p>

        <ul>
          <li>Before Service Photos</li>
          <li>After Service Photos</li>
        </ul>

        <p>
          These images are uploaded to our secure server as proof of completed
          service and are never used for advertising purposes.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2>4. Location Permission</h2>

        <p>
          The Partner App may access your device location while performing
          assigned services.
        </p>

        <p>Location information is used only for:</p>

        <ul>
          <li>Verifying arrival at customer location</li>
          <li>Managing assigned service orders</li>
          <li>Improving operational efficiency</li>
        </ul>

        <p>We do not sell or share location information for marketing.</p>
      </div>

      <div style={sectionStyle}>
        <h2>5. Storage Permission</h2>

        <p>Storage permission may be used to:</p>

        <ul>
          <li>Temporarily store captured images</li>
          <li>Upload service photographs</li>
        </ul>

        <p>
          The application does not access personal files unrelated to the
          service.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2>6. Notifications</h2>

        <p>The application may send notifications regarding:</p>

        <ul>
          <li>Assigned service orders</li>
          <li>Booking updates</li>
          <li>Service reminders</li>
          <li>Application updates</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2>7. How We Use Information</h2>

        <ul>
          <li>Create and manage user accounts</li>
          <li>Assign service requests</li>
          <li>Complete booked services</li>
          <li>Maintain service history</li>
          <li>Provide customer support</li>
          <li>Improve our services</li>
          <li>Maintain security and prevent misuse</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2>8. Payment Information</h2>

        <p>
          Payments are processed through secure third-party payment gateways.
          Cleanup does not store debit card, credit card, or banking details.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2>9. Sharing Information</h2>

        <p>We do not sell personal information.</p>

        <p>Information may be shared only with:</p>

        <ul>
          <li>Authorized Cleanup employees</li>
          <li>Assigned service partners</li>
          <li>Payment gateway providers</li>
          <li>Government authorities when legally required</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2>10. Data Protection</h2>

        <p>
          We implement appropriate technical and organizational security
          measures to protect personal information from unauthorized access,
          misuse, disclosure, or loss.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2>11. Data Retention</h2>

        <p>
          Personal information is retained only as long as necessary to provide
          services, comply with legal obligations, resolve disputes, and enforce
          agreements.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2>12. Children's Privacy</h2>

        <p>
          Our services are not intended for children under the age of 13. We do
          not knowingly collect personal information from children.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2>13. Third-Party Services</h2>

        <p>The application may use third-party services including:</p>

        <ul>
          <li>Google Play Services</li>
          <li>Firebase Cloud Messaging</li>
          <li>Google Maps (where applicable)</li>
          <li>Payment Gateway Providers</li>
        </ul>

        <p>
          These providers have their own privacy policies governing the use of
          information.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2>14. User Rights</h2>

        <p>Users may request to:</p>

        <ul>
          <li>Access their information</li>
          <li>Correct inaccurate information</li>
          <li>Delete their account where applicable</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2>15. Changes to this Policy</h2>

        <p>
          We may update this Privacy Policy periodically. Any changes will be
          published on this page with an updated effective date.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2>16. Contact Us</h2>

        <p>
          <strong>Company:</strong> Cleanup Car Service Pvt Ltd.
        </p>

        <p>
          <strong>Email:</strong> manoj.cleanup@gmail.com
        </p>

        <p>
          <strong>Phone:</strong> +91 9426235075
        </p>

        <p>
          <strong>Website:</strong> https://bcleanup.in
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;